<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="large-panel" @click.stop>
                <div class="dialog-title" v-t="'message.title_move_object'">
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body">
                     <table width=100% height=100% cellpadding=0 cellspacing=0>
                        <tr>
                            <td class="dialog-td">
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title" v-t="'message.title_move_destination_tree'">
                                    </div>
                                </div>
                                <div class="inner-panel-dialog">
                                    <dialogtree
                                        class="dialog-tree"
                                        v-bind:initialData="appData.tenantList"
                                        @on-selectnode="handleOnSelectNode"
                                        selectionType=0
                                        :showAdminUser="true"
                                        ref="dialogTree">
                                    </dialogtree>
                                </div>
                            </td>
                            <td class="dialog-td">
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title" v-t="'message.title_move_destination_layer'">
                                    </div>
                                </div>
                                <div class="selected-item-field" style="height: calc(100% - 40px)">
                                    <div class="inner-panel-dialog">
                                        <div class="default-message" v-if="showDestinationNodeHint & (destinationNode == null)"  v-t="'message.hint_selection_move_destination'">
                                        </div>
                                        <div v-if="destinationNode != null" class="userTag">
                                            <span class="userTag-name">{{ destinationGroupName }}</span>
                                            <span class="closeTag" @click="removeUserTag(tag)">×</span>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="this.disableMove" @click="$emit('move' , destinationNode.id)" v-t="'message.button_move'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import DialogTree from "./DialogTree.vue"
import commonUtil from './commonutil.js';
import constants from './constants.js';

export default {
    data() {
      return {
        fullGroupName: null,
        showDestinationNodeHint: true,
        destinationNode: null,
        destinationGroupName: null,
        disableMove: true
      };
    },
    methods: {
        handleOnSelectNode(data,selectedNode) {
            let self = this;
            server.post('/getinfo', {tenantId: this.appData.tenantList[0].tenantId, id: selectedNode.node.data.id})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            let acl = JSON.parse(res.data.acl)
                            if (acl.rw == null) {
                                commonUtil.notifyMessage(self,"Warning", commonUtil.getMessageText(self.$i18n,"error_cannot_select_no_writable_layer"));
                                return;
                            } else {
                                for (var i = 0 ; i< acl.rw.length ; i++) {
                                    if (acl.rw[i].split("-")[1] == self.appData.loginUserObjectId) {
                                        break;
                                    }
                                }
                                if (i == acl.rw.length) {
                                    commonUtil.notifyMessage(self,"Warning", commonUtil.getMessageText(self.$i18n,"error_cannot_select_no_writable_layer"));
                                    return;
                                }
                            }
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","handleOnSelectNode").replace("{code}",res.data.status));
                            return;
                    }
                    if (data.id == 1) {
                        self.destinationGroupName = data.label
                    } else {
                        let parentNode = selectedNode;
                        let nodeName = parentNode.node.data.label;
                        let array = []
                        while (parentNode.node.data.id != 1) {
                            if (data.type == constants.OBJECT_NODE) {
                                array.push(parentNode.node.data.label);
                                if (parentNode.node.data.id == self.sourceObjectId) {
                                    commonUtil.notifyMessage(self,"Warning", commonUtil.getMessageText(this.$i18n,"error_cannot_move_destination_node").replace('{layerName}',nodeName));
                                    return;
                                }
                            }
                            parentNode = parentNode.$parent;
                            nodeName = parentNode.node.data.label;
                        }
                        array.push(parentNode.node.data.label)   // add root node name
                        let groupName = ""
                        for (let i = (array.length-1) ; i >= 0 ; i--) {
                            if (groupName != "") {
                                groupName = groupName + "/"
                            }
                            groupName = groupName + array[i]
                        }
                        self.destinationGroupName = groupName
                    }
                    if (self.destinationNode == null) {
                        self.setDestinationNodeAfterRedraw(data);
                    } else {
                        self.destinationNode = data
                        self.disableMove = false;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "handleOnSelectNode", error);
                });
        },
        removeUserTag: function(tag) {
            this.$data.destinationNode = null;
            this.disableMove = true;
        },
        setDestinationNodeAfterRedraw(node) {
            // hint of destination node was remained after select the destination node..
            // it can clear by redraw
            this.showDestinationNodeHint = false;
            let self = this;
            this.$nextTick(() => {
                self.showDestinationNodeHint = true
                self.destinationNode = node
                self.disableMove = false;
            })
        },
    },
    components: {
        dialogtree: DialogTree
    },
    watch: {
        'appData.tenantList'(newVal) {
            this.show = false;
            this.$nextTick(() => {
                this.show = true;
            });
        }
    },
    props: ['appData' , 'sourceObjectId' ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dialog-tree >>> .el-tree-node__content {
    min-height: 40px !important;
    height: auto !important;
    white-space: normal !important;
    word-break: break-all !important;
    text-align: justify;
}
.dialog-tree >>>.el-tree-node__expand-icon {
    padding: 0px 28px !important;
}

</style>
